module.exports = __webpack_public_path__ + "static/mobile-frame-3387e58732f9572a7105db4c9a570ea3.png";